import { buildUploadKey, uploadFileToQiniu } from './qiniuUpload'

/** 文件上传至七牛（保留默认导出，供安装包等场景使用） */
export default function UploadFileToQiniu (path, file, datedir = false) {
  const key = buildUploadKey(path, file.name, datedir)
  return uploadFileToQiniu(file.blob, key)
}
